<template>
  <section style="display: grid; grid-template-columns: 200px; padding: 10px; row-gap: 10px; height: 295px;">
    <div style="display: flex; justify-content: space-between; column-gap: 10px;">
      <b-button
        type="is-link"
        expanded
        @click="() => sort('asc')"
      >
        ↑ {{ $t('fdc.GRID_COMPONENT.BUTTON.ASCENDING') }}
      </b-button>
      <b-button
        type="is-link"
        expanded
        @click="() => sort('desc')"
      >
        ↓ {{ $t('fdc.GRID_COMPONENT.BUTTON.DESCENDING') }}
      </b-button>
    </div>

    <div style="display: flex; justify-content: flex-start; column-gap: 3px;">
      <b-button
        type="is-text"
        ref="setConditionFilterButton"
        @click="setConditionFilter"
        :active="isConditionFilter"
      >
        {{ $t('fdc.GRID_COMPONENT.BUTTON.FILTER_BY_COND') }}
      </b-button>
      <!-- | -->
      <b-button
        type="is-text"
        ref="setValueFilterButton"
        @click="setValueFilter"
        :active="!isConditionFilter"
        v-if="showValueFilter === true"
      >
        {{ $t('fdc.GRID_COMPONENT.BUTTON.FILTER_BY_VAL') }}
      </b-button>
    </div>

    <div
      v-if="isConditionFilter === true"
      ref="conditionFilter"
      style="display: grid; grid-template-columns: 200px; row-gap: 7px; height: 172px;"
    >
      <p style="margin-bottom: 0">
        {{ $t('fdc.GRID_COMPONENT.LABEL.SHOW_ITEMS_WHERE_THE_VALUE') }}
      </p>
      <b-select
        v-model="operator1"
        expanded
      >
        <option>{{ $t('fdc.GRID_COMPONENT.LABEL.EQUALS') }}</option>
        <option>{{ $t('fdc.GRID_COMPONENT.LABEL.NOT_EQUAL') }}</option>
        <option>{{ $t('fdc.GRID_COMPONENT.LABEL.LESS_THAN') }}</option>
        <option>{{ $t('fdc.GRID_COMPONENT.LABEL.LESS_THAN_OR_EQUALS') }}</option>
        <option>{{ $t('fdc.GRID_COMPONENT.LABEL.GREATER_THAN') }}</option>
        <option>{{ $t('fdc.GRID_COMPONENT.LABEL.GREATER_THAN_OR_EQUALS') }}</option>
      </b-select>
      <b-input
        type="date"
        v-model="text1"
      />

      <div style="display: flex; justify-content: center;">
        <b-radio
          native-value="And"
          v-model="logicalOperator"
        >
          {{ $t('fdc.GRID_COMPONENT.LABEL.AND') }}
        </b-radio>
        <b-radio
          native-value="Or"
          v-model="logicalOperator"
        >
          {{ $t('fdc.GRID_COMPONENT.LABEL.OR') }}
        </b-radio>
      </div>

      <b-select
        v-model="operator2"
        expanded
      >
        <option>{{ $t('fdc.GRID_COMPONENT.LABEL.EQUALS') }}</option>
        <option>{{ $t('fdc.GRID_COMPONENT.LABEL.NOT_EQUAL') }}</option>
        <option>{{ $t('fdc.GRID_COMPONENT.LABEL.LESS_THAN') }}</option>
        <option>{{ $t('fdc.GRID_COMPONENT.LABEL.LESS_THAN_OR_EQUALS') }}</option>
        <option>{{ $t('fdc.GRID_COMPONENT.LABEL.GREATER_THAN') }}</option>
        <option>{{ $t('fdc.GRID_COMPONENT.LABEL.GREATER_THAN_OR_EQUALS') }}</option>
      </b-select>
      <b-input
        type="date"
        v-model="text2"
      />
    </div>

    <div
      v-if="isConditionFilter === false && showValueFilter === true"
      ref="valueFilter"
      style="display: grid; grid-template-columns: 200px; row-gap: 7px; height: 172px;"
    >
      <b-input
        type="date"
        placeholder="Search"
        v-model="text3"
      />
      <b-checkbox
        v-model="checkedAll"
      >
        {{ $t('fdc.GRID_COMPONENT.LABEL.SELECT_ALL') }}
      </b-checkbox>
      <div style="display: flex; flex-direction: column; height: 100px; overflow-y: scroll; border: 1px solid #d3d7e1; padding: 5px; border-radius: 5px;">
        <b-field
          v-for="value in filteredValues"
          :key="value"
        >
          <b-checkbox
            :native-value="value"
            v-model="checkedValues"
          >
            {{ value }}
          </b-checkbox>
        </b-field>
      </div>
    </div>

    <div style="display: flex; justify-content: flex-end;">
      <b-button @click="setModel()">
        {{ $t('fdc.COMMON.BUTTON.RESET') }}
      </b-button>
    </div>
  </section>
</template>

<script>
import dayjs from 'dayjs'

const EQUALS = 'Equals'
const NOT_EQUALS = 'Not equal'
const LESS_THAN = 'Less than'
const LESS_THAN_OR_EQUALS = 'Less than or equals'
const GREATER_THAN = 'Greater than'
const GREATER_THAN_OR_EQUALS = 'Greater than or equals'

const AND = 'And'

function evaluate (text1, operator, text2) {
  const value1 = new Date(text1).setHours(0, 0, 0, 0)
  const value2 = new Date(text2).setHours(0, 0, 0, 0)
  if (isNaN(value1)) {
    return true
  }

  switch (operator) {
    case EQUALS:
      return value1 === value2

    case NOT_EQUALS:
      return value1 !== value2

    case LESS_THAN:
      return value1 < value2

    case LESS_THAN_OR_EQUALS:
      return value1 <= value2

    case GREATER_THAN:
      return value1 > value2

    case GREATER_THAN_OR_EQUALS:
      return value1 >= value2

    default:
      return false
  }
}

export default {
  name: 'DateFilter',

  data () {
    return {
      operator1: EQUALS,
      operator2: EQUALS,
      logicalOperator: AND,
      text1: '',
      text2: '',
      text3: '',
      allValues: [],
      checkedValues: [],
      isConditionFilter: true,
      showValueFilter: true
    }
  },

  computed: {
    checkedAll: {
      get: function () {
        return this.allValues.length === this.checkedValues.length
      },
      set: function (newValue) {
        if (newValue) {
          this.checkedValues = [...this.allValues]
        } else {
          this.checkedValues = []
        }
      }
    },
    filteredValues: function () {
      const text = this.text3.trim().toLowerCase()
      if (text === '') {
        return this.allValues
      } else {
        return this.allValues.filter(value => value.toLowerCase().includes(text))
      }
    }
  },

  watch: {
    operator1: function () { this.params.filterChangedCallback() },
    operator2: function () { this.params.filterChangedCallback() },
    logicalOperator: function () { this.params.filterChangedCallback() },
    text1: function () { this.params.filterChangedCallback() },
    text2: function () { this.params.filterChangedCallback() },
    checkedValues: function () { this.params.filterChangedCallback() }
  },

  methods: {
    setConditionFilter () {
      this.isConditionFilter = true
      this.params.filterChangedCallback()
    },

    setValueFilter () {
      this.isConditionFilter = false
      this.params.filterChangedCallback()
    },

    init () {
      const set = new Set()
      const field = this.params.colDef.field
      this.params.api.forEachNode(node => set.add(dayjs(node.data[field]).format('YYYY-MM-DD')))
      this.allValues = Array.from(set)
      this.checkedValues = Array.from(set)
      if (this.allValues.length > 100) this.showValueFilter = false // value filter의 항목이 100건 이상일 경우에는 value filter 비활성화
      else this.isConditionFilter = false
    },

    onNewRowsLoaded () {
      this.init()
    },

    afterGuiAttached () {
      this.init()
    },

    isFilterActive () {
      if (this.isConditionFilter) {
        return this.text1 !== '' || this.text2 !== ''
      } else {
        return this.allValues.length !== this.checkedValues.length
      }
    },

    getModel () {
      return {
        operator1: this.operator1,
        operator2: this.operator2,
        logicalOperator: this.logicalOperator,
        text1: this.text1,
        text2: this.text2,
        checkedValues: this.checkedValues
      }
    },

    setModel (model) {
      if (model === undefined || model === null) {
        this.operator1 = EQUALS
        this.operator2 = EQUALS
        this.logicalOperator = AND
        this.text1 = ''
        this.text2 = ''
        this.checkedValues = [...this.allValues]
      } else {
        this.operator1 = model.operator1
        this.operator2 = model.operator1
        this.logicalOperator = model.operator1
        this.text1 = model.operator1
        this.text2 = model.operator1
        this.checkedValues = model.checkedValues
      }
    },

    doesFilterPass (params) {
      const field = this.params.colDef.field
      const value = params.data[field]

      if (this.isConditionFilter) {
        const result1 = evaluate(value, this.operator1, this.text1)
        const result2 = evaluate(value, this.operator2, this.text2)

        if (this.text2 === '') {
          return result1
        } else {
          if (this.logicalOperator === AND) {
            return result1 && result2
          } else {
            return result1 || result2
          }
        }
      } else {
        return this.checkedValues.includes(dayjs(value).format('YYYY-MM-DD'))
      }
    },

    sort (value) {
      const field = this.params.colDef.field
      this.params.columnApi.applyColumnState({
        state: [{
          colId: field,
          sort: value
        }]
      })
    }
  }
}
</script>
